export class Std {

    public static cleanUrl(test: string): string {
        return this.cleanStr(test).replace(/_/g, '-');
    }

    public static cleanStr(text: string): string {
        if (text === undefined) text = '';
        text = text.toLowerCase();
        text = text.replace(/á/g, 'a');
        text = text.replace(/é/g, 'e');
        text = text.replace(/í/g, 'i');
        text = text.replace(/ó/g, 'o');
        text = text.replace(/ö/g, 'o');
        text = text.replace(/ő/g, 'o');
        text = text.replace(/ú/g, 'u');
        text = text.replace(/ü/g, 'u');
        text = text.replace(/ű/g, 'u');
        text = text.replace(/Á/g, 'A');
        text = text.replace(/É/g, 'E');
        text = text.replace(/Í/g, 'I');
        text = text.replace(/Ó/g, 'O');
        text = text.replace(/Ö/g, 'O');
        text = text.replace(/Ő/g, 'O');
        text = text.replace(/Ú/g, 'U');
        text = text.replace(/Ü/g, 'U');
        text = text.replace(/Ű/g, 'U');
        text = text.replace(/ /g, '_');
        text = text.replace(/-/g, '_');
        text = text.replace(/,/g, '');
        text = text.replace(/\./g, '_');

        text = text.replace(/^\s+|\s+$/g, "").replace(/[_|\s]+/g, "_").replace(/[^a-z0-9_\.]+/g, "").replace(/[_]+/g, "_").replace(/^_+|_+$/g, "");
        return text;
    }

    public static priceFormat(price: string): string {
        var len:number = price.length;
        if (len < 4) {
            //száz
            return price;
        } else {
            if (len > 3 && len < 7) {
                //ezer
                var value = '';
                for (var i = 0; i < len; i++) {
                    value += price.substr(i, 1);
                    var thousand = len - 4;
                    if (i === thousand) {
                        value += ' ';
                    }
                }
                return value;
            } else {
                if (len > 6) {
                    //millió
                    var value = '';
                    for (var i = 0; i < len; i++) {
                        value += price.substr(i, 1);
                        var thousand:number = len - 4;
                        var milion:number = len - 7;
                        if (i === thousand || i === milion) {
                            value += ' ';
                        }
                    }
                    return value;
                }
            }
        }
        return price;
    }

    public static dateFormat(strDate:string){
        var date = new Date(strDate);
		if ( isNaN( date.getTime()) ) {
			if ( strDate === '0000-00-00' ) {
				return '';
			}
			return strDate;
		}
        var month:string = (date.getMonth()+1).toString();
        if ( month.length === 1 ) {
            month = '0' + month;
        }
        var day:string = date.getDate().toString();
        if ( day.length === 1 ) {
            day = '0' + day;
        }
        return date.getFullYear() + "." + month + '.' + day;
    }
}
